module.exports = "<div class=\"button-select\">\n    <label ng-class=\"{'active': model === firstChoiceValue, 'disabled': disabled}\"\n           ng-click=\"firstClicked()\">\n        {{firstChoiceLabel}}\n    </label>\n    <label ng-if=\"show2ndChoice\"\n           ng-class=\"{'active': model === secondChoiceValue, 'disabled': disabled}\"\n           ng-click=\"secondClicked()\">\n        {{secondChoiceLabel}}\n    </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-string-boolean-toggler.html
// module id = 560
// module chunks = 0